export default __webpack_public_path__ + "static/utilityBanner-41c927ec2431fbd16bbb045163b1a8a3.webp";